import { Link, TableCell } from "@mui/material";

import { type TransformedGCPTableUpdate } from "./types";

export const GCPReportUpdateToolRow = ({ row }: { row: TransformedGCPTableUpdate }) => (
  <>
    <TableCell data-cy={`${row.id}-customer`}>
      <Link
        href={`/customers/${row.customer.id}`}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        color="primary"
      >
        {row.customerName}
      </Link>
    </TableCell>
    <TableCell data-cy={`${row.id}-bqJobId`}>{row.bqJobId}</TableCell>
    <TableCell data-cy={`${row.id}-billingAccount`}>{row.billingAccount}</TableCell>
    <TableCell data-cy={`${row.id}-fromDate`}>{row.fromDate}</TableCell>
    <TableCell data-cy={`${row.id}-toDate`}>{row.toDate}</TableCell>
    <TableCell data-cy={`${row.id}-status`}>{row.status}</TableCell>
    <TableCell data-cy={`${row.id}-createdAt`}>{row.transform.createdAt}</TableCell>
    <TableCell data-cy={`${row.id}-email`}>{row.email}</TableCell>
  </>
);
